import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import { MailingId } from 'modules/mailing/types/mailing-interface';
import { MailingSettingsInterface } from 'modules/profile/mailing-settings/types/mailing-settings-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const useSendTestEmail = () => {
  const $ = _c(4);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher || $[2] !== t) {
    t1 = {
      fetcherSendTestEmail: async (mailingId, data) => {
        ;
        try {
          await fetcher(`/api/dashboard/customer/mailing/${mailingId}/send-test`, data);
          toast.success(t("dashboard.newsletter_editor.send_test_successful_message", {
            email: data.email
          }));
        } catch (t2) {
          const e = t2;
          throw e;
        }
      }
    };
    $[1] = fetcher;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};